/**
 * Lightweight analytics helper.
 *
 * `window.gtag` and `window.dataLayer` are bootstrapped in /public/index.html
 * BEFORE Google Analytics is actually loaded. The GA script itself only loads
 * after the user accepts cookies (see CookieBanner.jsx + loadGoogleAnalytics()).
 *
 * That means calling `track('click_call_now', { location: 'footer' })` is
 * ALWAYS safe — it pushes to dataLayer immediately, and when GA is later
 * loaded (or never loaded, if the user declined), the events are flushed or
 * simply discarded. We never block UX waiting on analytics.
 */
export const track = (eventName, params = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  try {
    window.gtag('event', eventName, params);
  } catch (e) {
    // Never let analytics break the app
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV === 'development') console.warn('[track] failed', e);
  }
};
